"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = void 0;
var Tab_1 = __importDefault(require("./Tab"));
exports.Tab = Tab_1.default;
exports.default = Tab_1.default;
//# sourceMappingURL=index.js.map